import { Routes } from '@angular/router';

export const examplesRoutes: Routes = [
  {
    path: 'courier-check-in',
    loadChildren: () =>
      import('./features/courier-check-in/courier-check-in-routing.module').then(
        (m) => m.courierCheckInRoutes
      ),
  },
];
